import { Alert } from "antd";
import isArray from "lodash/isArray";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";

const ErrorAlert = ({ error }) => {
  const { t } = useTranslation();
  return (
    <Alert
      className=" mb-8"
      message={t("forgot.errorTitle")}
      description={
        isArray(error) ? (
          <ul>
            {error?.map((error) => (
              <li key={uuidv4()}>{error}</li>
            ))}
          </ul>
        ) : (
          error
        )
      }
      type="error"
      showIcon
      closable
    />
  );
};

export default ErrorAlert;
